import { call, put, takeLatest } from "redux-saga/effects";

import { authAPI } from "../api/auth.api";
import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { authMessagesStrings } from "../assets/authMessages.strings";
import { loginSignupFailMessages } from "../assets/errorMessages.strings";
import { responseCodePipe } from "../../../services/code_matcher/response_code_pipe.service";

function* signup(action: Action) {
    try {
        const data = yield call(authAPI.signup, action.payload);

        yield put({
            type: AuthActionTypes.SIGNUP_SUCCESS,
            payload: data
        });
    } catch (e) {
        yield put({
            type: AuthActionTypes.SIGNUP_FAIL,
            error: e.response.data.code
        });
    }
}

export function* signupActionWatcher() {
    yield takeLatest(AuthActionTypes.SIGNUP, signup);
}

function* signupSuccess(_action: Action) {
    ToasterService.successToast(authMessagesStrings.SIGNUP_SUCCESS);
}

export function* signupSuccessWatcher() {
    yield takeLatest(AuthActionTypes.SIGNUP_SUCCESS, signupSuccess);
}

function* signupFail(action: Action) {
    ToasterService.errorToast(
        responseCodePipe(action.error, loginSignupFailMessages)
    );
}

export function* signupFailWatcher() {
    yield takeLatest(AuthActionTypes.SIGNUP_FAIL, signupFail);
}
